export class UrlHelper {

  public static getYoutubeVideoId = (url: string) => {
    var videoId = '';
    const urlParts = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if(urlParts[2] !== undefined) {
      const splitString = urlParts[2].split(/[^0-9a-z_\-]/i);
      videoId = splitString[0];
    }
    else {
      videoId = url;
    }
      return videoId;
  }

  public static getFormattedYoutubeUrl = (url) => {
    const videoId = UrlHelper.getYoutubeVideoId(url);

    return `https://www.youtube.com/embed/${videoId}`;
  }
}
